(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('MembershipDialogController', MembershipDialogController);

    MembershipDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Membership', 'PromoCode'];

    function MembershipDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Membership, PromoCode) {
        var vm = this;

        vm.membership = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.promocodes = PromoCode.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.membership.id !== null) {
                Membership.update(vm.membership, onSaveSuccess, onSaveError);
            } else {
                Membership.save(vm.membership, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('liverunApp:membershipUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.trialStartDate = false;
        vm.datePickerOpenStatus.trialEndDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
